  <template>
    <div>
      <div id="reviews-target"></div>

      <v-row class="mb-2">
        <v-col md="4" sm="12">
          <v-card dark color="pink accent-2" :loading="loadingStats">
            <v-card-title>{{ get(stats, 'data.total', '-') }}</v-card-title>
            <v-card-text class="white--text">Total de avaliações</v-card-text>
          </v-card>
        </v-col>

        <v-col md="4" sm="12">
          <v-card dark color="deep-purple accent-2" :loading="loadingStats">
            <v-card-title>{{ get(stats, 'data.without_reply', '-') }}</v-card-title>
            <v-card-text class="white--text">Avaliações sem resposta</v-card-text>
          </v-card>
        </v-col>

        <v-col md="4" sm="12">
          <v-card dark color="pink accent-2" :loading="loadingStats">
            <v-card-title>{{ get(stats, 'data.with_comment_without_reply', '-') }}</v-card-title>
            <v-card-text class="white--text">Avaliações com comentário e sem resposta</v-card-text>
          </v-card>
        </v-col>

        <v-col md="6" sm="6">
          <v-card dark color="blue lighten-1" :loading="loadingStats">
            <v-card-title>{{ get(stats, 'data.with_comment', '-') }}</v-card-title>
            <v-card-text class="white--text">Avaliações com comentário</v-card-text>
          </v-card>
        </v-col>

        <v-col md="6" sm="6">
          <v-card dark color="blue lighten-1" :loading="loadingStats">
            <v-card-title>{{ get(stats, 'data.without_comment', '-') }}</v-card-title>
            <v-card-text class="white--text">Avaliações sem comentário</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div v-show="chartLoaded" style="height: 370px">
          <v-row class="my-3 px-3">
            <apexchart v-if="chartLoaded" style="width: 100%" type="bar" height="350" :options="chartOptions"
              :series="chartSeries"></apexchart>
          </v-row>
        </div>
      </v-expand-transition>

      <v-card class="mb-4">
        <v-row class="px-2 mb-2">
          <v-col cols="12" sm="12" md="3" xs="12">
            <v-select v-model="filters.account" :error="accountError" :items="accounts && accounts.data"
              :loading="loadingAccounts" item-text="account_name" item-value="name" menu-props="auto" label="Conta"
              hide-details single-line solo color="primary" dense></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3" xs="12">
            <v-autocomplete autocomplete="off" v-model="filters.location" :error="locationError"
              :items="locations && locations.data" :loading="loadingLocations" v-on:keyup="onLocationKeyUp"
              :search-input.sync="searchLocation" item-text="location_name_code" item-value="name" menu-props="auto"
              label="Local ou Id" hide-details single-line solo color="primary" dense></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="2" xs="12">
            <v-select :items="starRatingOptions" v-model="filters.star_rating" item-text="text" item-value="id"
              menu-props="auto" label="Estrelas" hide-details single-line solo multiple clearable color="primary"
              dense></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="2" xs="12">
            <v-select :items="replyOptions" v-model="filters.with_reply" item-text="text" item-value="id" menu-props="auto"
              label="Resposta" hide-details single-line solo color="primary" dense clearable></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="2" xs="12">
            <v-select :items="commentOptions" v-model="filters.with_comment" item-text="text" item-value="id"
              menu-props="auto" label="Comentário" hide-details single-line solo color="primary" dense clearable></v-select>
          </v-col>
        </v-row>

        <v-expand-transition>
          <div v-show="moreFilters">
            <v-row class="px-4">
              <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
                <date-picker solo hide-details clearable label="De" noIcon dense v-on:change="changeSchedulingDateStart" />
              </v-col>

              <v-col class="py-2" cols="12" sm="4" md="2" xs="12">
                <date-picker solo hide-details clearable label="Até" noIcon dense :min="filters.date_start"
                  v-on:change="changeSchedulingDateEnd" />
              </v-col>

              <v-col class="py-2" cols="12" sm="12" md="2" xs="12">
                <v-autocomplete multiple autocomplete="off" v-on:keyup="onStateKeyUp" :search-input.sync="searchState"
                  v-model="filters.state" :error="stateError" :items="states && states.data" :loading="loadingStates"
                  item-text="administrative_area" item-value="administrative_area" menu-props="auto" label="Estado"
                  hide-details single-line clearable solo color="primary" dense></v-autocomplete>
              </v-col>

              <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
                <v-autocomplete multiple autocomplete="on" v-model="filters.city" :error="cityError"
                  :items="cities && cities.data" :loading="loadingCities" v-on:keyup="onCityKeyUp" item-text="locality"
                  item-value="locality" menu-props="auto" label="Cidade" hide-details single-line solo clearable
                  color="primary" dense>
                  <template v-slot:append-item>
                    <v-list-item @click="loadMoreCities" v-show="cities.next_page_url" :disabled="loadingCities">
                      <v-list-item-title class="text-center">{{ loadingCities ? 'Carregando...' : 'Carregar mais' }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
                <v-autocomplete autocomplete="off" v-on:keyup="onAddressKeyUp" :search-input.sync="searchAddress"
                  v-model="filters.address" :error="addressError" :items="addresses && addresses.data"
                  :loading="loadingAddress" item-text="address_line_one" item-value="address_line_one" menu-props="auto"
                  label="Endereço" hide-details single-line solo clearable color="primary" dense></v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="px-4">
              <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
                <v-autocomplete autocomplete="off" v-on:keyup="onKeywordKeyUp" v-model="filters.keywords"
                  :error="keywordsError" :items="keywords && keywords.data" :loading="loadingKeywords"
                  :search-input.sync="searchKeyword" item-text="name" item-value="id" menu-props="auto" label="Tags"
                  color="primary" hide-details single-line solo dense multiple clearable></v-autocomplete>
              </v-col>
              <v-col class="py-2" cols="12" sm="12" md="3" xs="12">
                <v-autocomplete multiple autocomplete="off" v-model="filters.labels" :error="labelsError" :items="labels"
                  :loading="loadingLabels" :search-input.sync="searchLabels" v-on:keyup="onLabelsKeyUp" item-text="name"
                  item-value="name" menu-props="auto" label="Labels" hide-details single-line solo clearable color="primary"
                  dense></v-autocomplete>
              </v-col>
              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <v-select :items="orderDateOptions" v-model="filters.sort_by_date" item-text="text" item-value="id"
                  menu-props="auto" label="Ordenar por data" hide-details single-line solo color="primary" dense
                  clearable></v-select>
              </v-col>
              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <v-select :items="orderStarRatingOptions" v-model="filters.sort_by_stars" item-text="text" item-value="id"
                  menu-props="auto" label="Ordenar por estrelas" hide-details single-line solo color="primary" dense
                  clearable></v-select>
              </v-col>
              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <v-select :items="ignoredOptions" v-model="filters.ignored" item-text="text" item-value="id"
                  menu-props="auto" label="Ignoradas" hide-details single-line solo color="primary" dense
                  clearable></v-select>
              </v-col>
              <v-col class="py-2" cols="12" sm="4" md="3" xs="12">
                <v-autocomplete multiple autocomplete="off" v-model="filters.words" :items="wordOptions" :loading="loadingWords" :search-input.sync="searchWords"
                  item-text="name" item-value="name" menu-props="auto" label="Que Contenha" color="primary"
                  hide-details single-line solo dense clearable v-on:keyup="onWordKeyUp"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>

        <v-card-actions class="mt-4">
          <v-btn small outlined color="primary" @click="moreFilters = !moreFilters">
            <v-icon left>{{ moreFilters ? 'mdi-filter-minus-outline' : 'mdi-filter-plus-outline' }}</v-icon>
            {{ moreFilters ? 'Menos' : 'Mais' }} filtros
          </v-btn>
          <v-btn small outlined color="primary" @click="clearFilters">
            <v-icon left>mdi-filter-off-outline</v-icon>
            Limpar filtros
          </v-btn>
          <v-btn :loading="loadingReport" color="info" small @click="exportReviews">
            <v-icon left>mdi-download</v-icon>
            Exportar
          </v-btn>
          <v-btn small :loading="loading" color="primary" @click="applyFilters">
            <v-icon left>mdi-filter</v-icon>
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>

      <div v-if="loadingSkeleton">
        <v-skeleton-loader class="mb-2" v-for="item in 10" :key="item" elevation="2"
          type="article, actions"></v-skeleton-loader>
      </div>
      <div v-else>
        <card-review v-for="review in reviews.data" :key="review.id" :review="review"
          :on-ignored="() => onReviewIgnored(review)" :on-replied="onReviewReplied" :on-review-updated="onReviewUpdated"
          :on-reply-deleted="onReviewReplyDeleted" :firebase-ref="`/reviews/${review.review_id}`" />
      </div>

      <v-row class="pa-4">
        <v-spacer />
        <v-btn :disabled="page === 1" icon elevation="2" class="mr-1" @click="previousPage">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn :disabled="reviews && Array.isArray(reviews.data) && reviews.data.length < limit" icon elevation="2"
          class="ml-1" @click="nextPage">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer />
      </v-row>

      <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            Ok
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </template>

  <script>
  import { mapState } from 'vuex'
  import { debounce, get } from 'lodash'
  import { handleResponseError } from '@/api/handleError'
  import DatePicker from '@/components/DatePicker'
  import CardReview from '@/views/Reviews/CardReview'

  export default {
    name: 'Reviews',
    computed: {
      ...mapState({
        reviews: state => state.reviews.all,
        accounts: state => state.accounts.all,
        locations: state => state.locations.all,
        cities: state => state.locations.cities,
        states: state => state.locations.states,
        labels: state => {
          let newLabels = []
          const labels = state.locations.labels
          for (const id in labels.data) {
            newLabels.push({ id, name: labels.data[id].name })
          }
          return newLabels
        },
        addresses: state => state.locations.addresses,
        keywords: state => state.keywords.all,
        stats: state => state.reviews.stats,
        chartData: state => state.reviews.chartData,
        reviewsExport: state => state.reviews.reviewsExport,
      }),
      get() {
        return get
      },
    },
    components: {
      DatePicker,
      CardReview,
    },
    methods: {
      fetchReviews: async function (scroll) {
        this.loading = true
        await this.$store.dispatch('reviews/getReviews', {
          ignored: this.filters.ignored,
          account: this.filters.account,
          location: this.filters.location,
          state: this.filters.state,
          city: this.filters.city,
          labels: this.filters.labels,
          address: this.filters.address,
          stars: this.filters.star_rating,
          keywords: this.filters.keywords,
          date_start: this.filters.date_start,
          date_end: this.filters.date_end,
          with_comment: this.filters.with_comment,
          with_reply: this.filters.with_reply,
          sort_by_stars: this.filters.sort_by_stars,
          sort_by_date: this.filters.sort_by_date,
          limit: this.limit,
          page: this.page,
          desc: true,
          sort: 'create_time',
          filter_words: this.filters.filter_words,
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar as avaliações.')
          this.showNotification(message, 'red darken-2')
          this.loading = false
        })
        this.loading = false
        this.loadingSkeleton = false

        if (scroll) this.toTop()

        await this.fetchStats()
        await this.fetchChartData()
      },
      fetchStats: async function () {
        this.loadingStats = true
        await this.$store.dispatch('reviews/getStats', {
          ignored: this.filters.ignored,
          account: this.filters.account,
          location: this.filters.location,
          state: this.filters.state,
          city: this.filters.city,
          address: this.filters.address,
          stars: this.filters.star_rating,
          keywords: this.filters.keywords,
          date_start: this.filters.date_start,
          date_end: this.filters.date_end,
          with_comment: this.filters.with_comment,
          with_reply: this.filters.with_reply,
          sort_by_stars: this.filters.sort_by_stars,
          sort_by_date: this.filters.sort_by_date,
          filter_words: this.filters.words,
          limit: this.limit,
          page: this.page,
          desc: true,
          sort: 'create_time',
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar as estatísticas.')
          this.showNotification(message, 'red darken-2')
          this.loading = false
        })
        this.loadingStats = false
      },
      fetchChartData: async function () {
        this.loadingChart = true
        await this.$store.dispatch('reviews/getChartData', {
          ignored: this.filters.ignored,
          account: this.filters.account,
          location: this.filters.location,
          state: this.filters.state,
          city: this.filters.city,
          address: this.filters.address,
          stars: this.filters.star_rating,
          keywords: this.filters.keywords,
          date_start: this.filters.date_start,
          date_end: this.filters.date_end,
          with_comment: this.filters.with_comment,
          with_reply: this.filters.with_reply,
          sort_by_stars: this.filters.sort_by_stars,
          sort_by_date: this.filters.sort_by_date,
          filter_words: this.filters.words,
          limit: this.limit,
          page: this.page,
          desc: true,
          sort: 'create_time',
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar os dados do gráfico.')
          this.showNotification(message, 'red darken-2')
          this.loading = false
        })
        this.loadingChart = false
      },
      fetchAccounts: async function () {
        this.loadingAccounts = true
        await this.$store.dispatch('accounts/getAccounts', { limit: 0 }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar as contas.')
          this.showNotification(message, 'red darken-2')
          this.loadingAccounts = false
        })
        this.loadingAccounts = false
      },
      fetchLocations: async function () {
        if (!this.filters.account) return
        this.loadingLocations = true
        await this.$store.dispatch('locations/getLocations', {
          account: this.filters.account,
          search: this.searchLocation,
          limit: 100,
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar os locais.')
          this.showNotification(message, 'red darken-2')
          this.loadingLocations = false
        })
        this.loadingLocations = false
      },
      fetchLocationStates: async function () {
        this.accountError = false
        if (!this.filters.account) {
          this.accountError = true
          return
        }

        this.loadingStates = true
        await this.$store.dispatch('locations/getStates', {
          limit: 200,
          search: this.searchState,
          account: this.filters.account,
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar os estados.')
          this.showNotification(message, 'red darken-2')
          this.loadingAccounts = false
        })
        this.loadingStates = false
      },
      fetchLocationLabels: async function () {
        this.labelsError = false
        this.loadingLabels = true
        await this.$store.dispatch('locations/getLabels', {
          limit: 200,
          search: this.searchLabels,
          account: this.filters.account,
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar as labels.')
          this.showNotification(message, 'red darken-2')
          this.loadingLabels = false
        })
        this.loadingLabels = false
      },
      fetchLocationCities: async function () {
        this.accountError = false
        if (!this.filters.account) {
          this.accountError = true
          return
        }

        this.loadingCities = true
        await this.$store.dispatch('locations/getCities', {
          limit: this.limitCities,
          search: this.searchCity,
          account: this.filters.account,
          page: this.pageCities,
          states: [...this.filters.state],
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar as cidades.')
          this.showNotification(message, 'red darken-2')
          this.loadingCities = false
        })
        this.loadingCities = false
      },
      /**
       * Carrega mais cidades para o filtro de cidades (com paginação)
       */
      loadMoreCities() {
        this.limitCities = this.limitCities + 100
        this.fetchLocationCities()
      },
      fetchLocationAddresses: async function () {
        this.accountError = false
        if (!this.filters.account) {
          this.accountError = true
          return
        }

        this.loadingAddress = true
        await this.$store.dispatch('locations/getAddresses', {
          limit: 200,
          search: this.searchAddress,
          account: this.filters.account,
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar os endereços.')
          this.showNotification(message, 'red darken-2')
          this.loadingAddress = false
        })
        this.loadingAddress = false
      },
      fetchLocationKeywords: async function () {
        this.accountError = false
        if (!this.filters.account) {
          this.accountError = true
          return
        }

        this.loadingKeywords = true
        await this.$store.dispatch('keywords/getKeywords', {
          limit: 200,
          search: this.searchKeyword,
          account: this.filters.account,
        }).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar os endereços.')
          this.showNotification(message, 'red darken-2')
          this.loadingKeywords = false
        })
        this.loadingKeywords = false
      },
      async fetchWords() {
        this.loadingWords = true;
        try {
          const response = await this.$store.dispatch('reviews/getWords', {
            search: this.searchWords,
            account: this.filters.account, 
            limit: 100,
          });
          console.log(response);
          this.wordOptions = response.data;
        } catch (e) {
          const message = handleResponseError(e, 'Ocorreu um erro ao buscar as palavras.');
          this.showNotification(message, 'red darken-2');
        }
        this.loadingWords = false;
      },

      onWordKeyUp: debounce(function () {
        this.fetchWords();
      }, 400),

      applyFilters() {
        this.loadingSkeleton = true
        console.log('Words filter before processing:', this.filters.words); // Debugging

        this.filters.filter_words = this.filters.words.map((word) =>
            word
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
        );

        console.log('Filter words after processing:', this.filters.filter_words);

        if (this.page === 1) {
          this.fetchReviews(true)
        } else {
          this.page = 1
        }
      },
      changeSchedulingDateStart(date) {
        this.filters.date_start = date
      },
      changeSchedulingDateEnd(date) {
        this.filters.date_end = date
      },
      showNotification(message, color) {
        this.snackbar.text = message
        this.snackbar.show = true
        this.snackbar.color = color
      },
      onReviewIgnored(review) {
        this.fetchReviews()
        this.showNotification(review.ignored ? 'Avaliação atualizada!' : 'Avaliação ignorada!', 'green')
      },
      onReviewReplied() {
        this.fetchReviews()
        this.showNotification('Avaliação respondida!', 'green')
      },
      onReviewUpdated() {
        this.fetchReviews()
        this.showNotification('Avaliação atualizada!', 'green')
      },
      onReviewReplyDeleted() {
        this.fetchReviews()
        this.showNotification('Resposta excluída!', 'green')
      },
      nextPage() {
        this.page = this.page + 1
      },
      previousPage() {
        this.page = this.page - 1 > 0 ? this.page - 1 : 1
      },
      toTop() {
        this.$vuetify.goTo('#reviews-target')
      },
      clearFilters() {
        this.filters = {
          ignored: 0,
          star_rating: [],
          account: null,
          location: null,
          date_start: '',
          date_end: '',
          status: '',
          with_comment: null,
          with_reply: null,
          sort_by_stars: null,
          sort_by_date: null,
          city: [],
          state: [],
          address: '',
          keywords: [],
        }
      },
      async exportReviews() {
        if (!this.filters.account) {
          this.showNotification('Selecione uma conta', 'red darken-2')
          return
        }
        const filters = {
          ignored: this.filters.ignored,
          account: this.filters.account,
          location: this.filters.location,
          state: this.filters.state,
          city: this.filters.city,
          address: this.filters.address,
          stars: this.filters.star_rating,
          keywords: this.filters.keywords,
          date_start: this.filters.date_start,
          date_end: this.filters.date_end,
          with_comment: this.filters.with_comment,
          with_reply: this.filters.with_reply,
          sort_by_stars: this.filters.sort_by_stars,
          sort_by_date: this.filters.sort_by_date,
          filter_words: this.filters.words,
          desc: true,
          sort: 'create_time'
        }
        this.loadingReport = true
        await this.$store.dispatch('reviews/exportReviews', filters).catch(e => {
          const message = handleResponseError(e, 'Ocorreu um erro ao gerar o relatório.')
          this.showNotification(message, 'red darken-2')
          this.loadingReport = false
        })
        this.loadingReport = false
      },
      onLocationKeyUp: debounce(function () {
        this.fetchLocations()
      }, 400),
      onCityKeyUp: debounce(function () {
        this.fetchLocationCities()
      }, 400),
      onAddressKeyUp: debounce(function () {
        this.fetchLocationAddresses()
      }, 400),
      onKeywordKeyUp: debounce(function () {
        this.fetchLocationKeywords()
      }, 400),
      onStateKeyUp: debounce(function () {
        this.fetchLocationStates()
      }, 400),
      onLabelsKeyUp: debounce(function () {
        this.fetchLocationLabels()
      }, 400)
    },
    watch: {
      'filters.account': function (account) {
        this.page = 1
        this.filters.location = null
        if (account) {
          this.fetchLocations()
          this.fetchLocationStates()
          if (this.filters.state.length) {
            this.fetchLocationCities()
          }
          this.fetchLocationLabels()
          this.fetchLocationAddresses()
          this.fetchLocationKeywords()
        }
      },
      'filters.state': debounce(function () {
        this.fetchLocationCities()
      }, 400),
      page() {
        this.loadingSkeleton = true
        this.fetchReviews(true)
      },
      'filters.words': function () {
        this.page = 1;
      },
      chartData(data) {
        if (!data) return

        this.chartOptions.xaxis.categories = data.date_labels
        this.chartSeries = [
          {
            name: `Total`,
            data: data.total,
          },
          {
            name: `Respondidas`,
            data: data.with_reply,
          },
          {
            name: `Com comentário`,
            data: data.with_comment,
          },
        ]
        this.chartLoaded = true
      },
      reviewsExport(blob, oldBlob) {
        if (blob && blob !== oldBlob) {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'reviews.xlsx')
          document.body.appendChild(link)
          link.click()
        }
      }
    },
    created() {
      this.fetchAccounts()
      this.fetchReviews()
      this.fetchWords()
    },
    destroyed() {
      this.$store.dispatch('locations/clearLocations')
    },
    data: () => ({
      chartLoaded: false,
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false
          }
        },
        colors: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(153, 102, 255, 1)'],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          // title: {
          //   text: 'Quantidade',
          // },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' avaliações'
            },
          },
        },
      },
      chartSeries: [],
      loadingSkeleton: false,
      loadingReport: false,
      moreFilters: false,
      searchLocation: '',
      searchState: '',
      searchCity: '',
      searchLabels: '',
      searchAddress: '',
      searchKeyword: '',
      accountError: null,
      locationError: null,
      stateError: null,
      labelsError: null,
      cityError: null,
      addressError: null,
      keywordsError: null,
      sortBy: '',
      loading: false,
      loadingStats: false,
      loadingLabels: false,
      loadingChart: false,
      loadingAccounts: false,
      loadingLocations: false,
      loadingStates: false,
      loadingCities: false,
      loadingAddress: false,
      loadingKeywords: false,
      searchWords: '',
      loadingWords: false,
      wordOptions: [],
      sortDesc: '',
      limit: 10,
      page: 1,
      snackbar: {
        text: '',
        show: false,
        color: 'info',
      },
      filters: {
        ignored: 0,
        star_rating: [],
        labels: [],
        account: null,
        location: null,
        date_start: '',
        date_end: '',
        status: '',
        with_comment: null,
        with_reply: null,
        sort_by_stars: null,
        sort_by_date: null,
        city: [],
        state: [],
        address: '',
        keywords: [],
        words: [],
        filter_words: [],
      },
      commentOptions: [
        { id: 1, text: 'Com comentário' },
        { id: 0, text: 'Sem comentário' },
      ],
      replyOptions: [
        { id: 1, text: 'Com resposta' },
        { id: 0, text: 'Sem resposta' },
      ],
      starRatingOptions: [
        { id: 1, text: '1' },
        { id: 2, text: '2' },
        { id: 3, text: '3' },
        { id: 4, text: '4' },
        { id: 5, text: '5' },
      ],
      orderDateOptions: [
        { id: 'desc', text: 'Mais recentes' },
        { id: 'asc', text: 'Menos recentes' },
      ],
      orderStarRatingOptions: [
        { id: 'desc', text: 'Mais estrelas' },
        { id: 'asc', text: 'Menos estrelas' },
      ],
      ignoredOptions: [
        { id: null, text: 'Com ignoradas' },
        { id: 0, text: 'Sem ignoradas' },
        { id: 1, text: 'Somente ignoradas' },
      ],
      limitCities: 100,
      pageCities: 1
    }),
  }
  </script>
